<!-- 工控-配件库存管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增配件出库
      </el-button>
      <el-button type="success" @click="onPrint()">
        <i class="fa fa-print"></i> 打印设备交接单
      </el-button>
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.IpcAccessoryModelID"
          url="ipc/model/accessory/list?order=name"
          clearable
          placeholder="选择配件型号"
          no-data-text="没有配件型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <select2
          labelName="ClientName"
          v-model="former.ClientID"
          url="client/list"
          clearable
          placeholder="选择客户"
          no-data-text="没有客户"
          :urlParams="{
            where: {},
          }"
          q="ClientName:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="ipc/accessory/stock-status-list"
          clearable
          placeholder="请选择状态"
          no-data-text="没有状态"
        ></select2
        >&nbsp;
        <el-input
          v-model.trim="former['SN:like']"
          placeholder="配件SN"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      @selection-change="onSelectChanged"
      :row-key="getRowKey"
    >
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="IpcAccessoryModel.Name" label="配件名称" />
      <el-table-column
        prop="IpcAccessoryModel.Brand"
        label="品牌"
        width="150"
      />
      <el-table-column
        prop="IpcAccessoryModel.ModelNumber"
        label="型号"
        width="150"
      />
      <el-table-column prop="SN" label="配件SN" width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.SN !== ''">
            {{ scope.row.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="IpcProduct.SN" label="关联产品SN" width="180">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IpcProduct !== null">
            {{ scope.row.IpcProduct.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Client.ClientName" label="客户" width="150" />
      <el-table-column
        prop="IsQuality"
        label="是否在保"
        align="center"
        width="80"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsQuality === '否'" type="warning"> 过保 </el-tag>
          <el-tag v-else-if="row.IsQuality === '是'" type="success">
            在保
          </el-tag>
          <el-tag v-else> {{ row.IsQuality }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" align="center" width="80">
        <template slot-scope="{ row }">
          <div v-if="row.Status !== 0">
            <el-tag v-if="row.Status === 1" type="warning">
              {{ row.StatusName }}
            </el-tag>
            <el-tag v-else type="success">
              {{ row.StatusName }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'ipc_accessory_stock-DELETE'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <out :visible.sync="outVisible" @form:saved="flush" />
    <edit v-model="item" :visible.sync="editVisible" @form:saved="flush" />
  </el-card>
</template>

<script>
import Out from "./out.vue";
import Edit from "./edit.vue";

export default {
  components: {
    Out,
    Edit,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        IpcAccessoryModelID: "",
        Status: "",
        ClientID: "",
        "SN:like": "",
      },
      item: this.getEmptyItem(),
      createVisible: false,
      outVisible: false,
      editVisible: false,
      accIds: [],
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    flush() {
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipc/accessory/stock-list", {
          params: {
            where: {
              IpcAccessoryModelID: this.former.IpcAccessoryModelID,
              Status: this.former.Status,
              ClientName: this.former.ClientName,
              "SN:like": this.former["SN:like"],
            },
            Tags: this.former.Tags,
            ...this.pager,
            with: ["IpcAccessoryModel", "IpcProduct", "Client"],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.outVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此配件吗？", "提示")
        .then(() => this.$axios.delete(`ipc/accessory/stock-delete/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {};
    },
    onPrint() {
      if (this.accIds.length > 0) {
        this.$axios
          .request({
            url: "ipc/accessory/stock-out/print",
            method: "post",
            responseType: 'blob',
            data: {
              ids:this.accIds,
            },
          })
          .then((res) => {
            this.autoDownloadBlobFile(
            new window.Blob([res.data], { type: 'application/vnd.ms-excel' }),
            '设备交接单.xlsx'
          );
            // if (!res) {
            //   return;
            // }
            // const blob = new Blob([res.data], {
            //   type: "application/vnd.ms-excel",
            // }); // 构造一个blob对象来处理数据，并设置文件类型

            // if (window.navigator.msSaveOrOpenBlob) {
            //   //兼容IE10
            //   navigator.msSaveBlob(blob, fName);
            // } else {
            //   const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            //   const a = document.createElement("a"); //创建a标签
            //   a.style.display = "none";
            //   a.href = href; // 指定下载链接
            //   a.download = "设备交接单.xlsx"; //指定下载文件名
            //   a.click(); //触发下载
            //   URL.revokeObjectURL(a.href); //释放URL对象
            // }
            // // 这里也可以不创建a链接，直接window.open(href)也能下载
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.warning("请至少选择一个配件!");
        return;
      }
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onSelectChanged(options) {
      this.accIds = options.map((x) => x.ID);
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>
